const createAction = (type) => (payload, error) => ({
  type,
  payload,
  error
});

export default createAction;
